import { FC } from 'react'
import { Move, Pencil, RotateCw, Trash2 } from 'lucide-react'
import { Tool } from '../general/Tool.tsx'
import { useControls } from '../../hooks/useControls.ts'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogTitle,
    DialogTrigger,
} from '@/components/ui/dialog.tsx'
import { Button } from '@/components/ui/button.tsx'
import { useAtomValue } from 'jotai'
import { activeGeometryAtom } from '@/js/editor/state/editorUiAtoms.ts'

type PoiToolsProps = {
    direction?: 'horizontal' | 'vertical'
    onMap?: boolean
}

export const PoiTools: FC<PoiToolsProps> = ({ onMap = false, direction = 'horizontal' }) => {
    const currentLayer = useAtomValue(activeGeometryAtom)
    const { setTool, tool: activeTool, removeActiveGeometry } = useControls()

    const isPolygon = currentLayer?.type === 'Polygon'
    const isPoint = currentLayer?.type === 'Point'
    const canMove = isPoint || isPolygon

    const deleteActiveGeometry = () => {
        removeActiveGeometry()
    }

    const ControlBar = () => {
        return (
            <div
                className={`${
                    direction === 'vertical'
                        ? 'flex w-10 flex-col items-center gap-2'
                        : 'flex w-32 items-center justify-end gap-2'
                }`}
            >
                {canMove && (
                    <Tool title="bewegen" icon={Move} active={activeTool === 'move'} action={() => setTool('move')} />
                )}

                {isPolygon && (
                    <>
                        <Tool
                            title="editieren"
                            icon={Pencil}
                            active={activeTool === 'edit'}
                            action={() => setTool('edit')}
                        />

                        <Tool
                            title="rotieren"
                            icon={RotateCw}
                            active={activeTool === 'rotate'}
                            action={() => setTool('rotate')}
                        />
                    </>
                )}

                <Dialog>
                    <DialogTrigger asChild>
                        <Tool title={'löschen'} icon={Trash2} />
                    </DialogTrigger>
                    <DialogContent className={'z-2005 max-w-75'}>
                        <DialogTitle>Markierung löschen?</DialogTitle>
                        <DialogDescription>
                            Gelöschte Markierungen können nicht wiederhergestellt werden.
                        </DialogDescription>
                        <DialogFooter>
                            <Button variant={'destructive'} onClick={deleteActiveGeometry}>
                                Löschen
                            </Button>
                        </DialogFooter>
                    </DialogContent>
                </Dialog>
            </div>
        )
    }

    return onMap ? (
        <div className={'absolute left-1/2 bottom-1 bg-mm-blue z-1200'}>
            <ControlBar />
        </div>
    ) : (
        <ControlBar />
    )
}
